// Import jquery
import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;

// Import bootstrap
window.bootstrap = require("bootstrap")